/*
 * WhatsApp (snippets/whatsapp-flotante.liquid y enlace de snippets/pdp-munum-bloque.liquid).
 * - Medición: en cada clic a un enlace con data-whatsapp-location hace dataLayer.push y
 *   Shopify.analytics.publish('whatsapp_click', …). Sin gtag ni fbq: las etiquetas viven en Tag Manager.
 *   No se cancela la navegación: el push es síncrono y el enlace se abre igual.
 * - Etiqueta en página de producto: una sola vez por visitante, a los 20 s, con X para cerrar.
 */
(function () {
  if (window.munumWhatsapp) return;
  window.munumWhatsapp = true;

  var STORAGE_KEY = 'munum_wa_teaser_visto';
  var TEASER_DELAY = 20000;

  function track(link) {
    try {
      var data = {
        event: 'whatsapp_click',
        whatsapp_location: link.dataset.whatsappLocation,
        page_type: link.dataset.whatsappPageType || 'other',
      };
      if (link.dataset.whatsappProduct) data.product_name = link.dataset.whatsappProduct;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var payload = {
          whatsapp_location: data.whatsapp_location,
          page_type: data.page_type,
        };
        if (data.product_name) payload.product_name = data.product_name;
        window.Shopify.analytics.publish('whatsapp_click', payload);
      }
    } catch (error) {
      // La medición nunca debe impedir que se abra WhatsApp.
    }
  }

  function markTeaserSeen() {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (error) {}
  }

  function teaserSeen() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (error) {
      // Sin almacenamiento no se puede garantizar "una sola vez": no se muestra.
      return true;
    }
  }

  var float = document.querySelector('[data-wa-float]');

  function hideTeaser() {
    if (!float) return;
    float.classList.remove('wa-float--teaser');
    var close = float.querySelector('[data-wa-close]');
    if (close) close.hidden = true;
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('a[data-whatsapp-location]');
      if (!link) return;
      track(link);
      if (float && float.classList.contains('wa-float--teaser')) {
        markTeaserSeen();
        hideTeaser();
      }
    },
    true
  );

  if (!float || !float.hasAttribute('data-wa-teaser') || teaserSeen()) return;

  var closeButton = float.querySelector('[data-wa-close]');
  if (closeButton) {
    closeButton.addEventListener('click', function () {
      markTeaserSeen();
      hideTeaser();
    });
  }

  setTimeout(function () {
    if (teaserSeen()) return;
    markTeaserSeen();
    float.classList.add('wa-float--teaser');
    if (closeButton) closeButton.hidden = false;
  }, TEASER_DELAY);
})();
